import React from 'react';
import { Card } from './Card';

interface TimeoutErrorProps {
  onRetry: () => void;
  supportUrl?: string;
}

export const TimeoutError: React.FC<TimeoutErrorProps> = ({ 
  onRetry, 
  supportUrl = 'https://wordpress.org/support/plugin/accessibility-plus/#new-topic-0' 
}) => {
  return (
    <div className="cy:flex cy:items-center cy:justify-center cy:min-h-[400px] cy:px-4">
      <Card className="cy:border-0 cy:bg-white cy:rounded-lg cy:shadow-lg cy:max-w-md cy:w-full">
        <div className="cy:p-6 cy:text-center">
          {/* Illustration */}
          <div className="cy:flex cy:items-center cy:justify-center cy:mb-6">
            <div className="cy:relative">
              {/* Blue circle background */}
              <div className="cy:w-24 cy:h-24 cy:bg-blue-100 cy:rounded-full cy:flex cy:items-center cy:justify-center">
                {/* Laptop/Tablet icon */}
                <svg 
                  className="cy:w-16 cy:h-16 cy:text-blue-600" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={1.5} 
                    d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" 
                  />
                </svg>
              </div>
              {/* Clock icon overlay */}
              <div className="cy:absolute cy:-top-1 cy:-right-1 cy:w-8 cy:h-8 cy:bg-orange-500 cy:rounded-full cy:flex cy:items-center cy:justify-center cy:border-2 cy:border-white">
                <svg 
                  className="cy:w-5 cy:h-5 cy:text-white" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" 
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* Heading */}
          <h2 
            className="cy:m-0 cy:mb-3 cy:text-gray-900" 
            style={{ fontSize: '20px', fontWeight: 600, lineHeight: '120%' }}
          >
            Accessibility checker timed out
          </h2>

          {/* Description */}
          <p 
            className="cy:m-0 cy:mb-6 cy:text-gray-600" 
            style={{ fontSize: '14px', fontWeight: 400, lineHeight: '140%' }}
          >
            The scan took longer than expected and could not be completed. Please try scanning again.
          </p>

          {/* Retry Button */}
          <button
            onClick={onRetry}
            className="cy:w-full cy:bg-blue-600 cy:hover:bg-blue-700 cy:text-white cy:py-3 cy:px-4 cy:rounded-lg cy:border-0 cy:cursor-pointer cy:transition-colors cy:mb-4"
            style={{ 
              fontSize: '16px', 
              fontWeight: 600, 
              lineHeight: '100%'
            }}
          >
            Retry
          </button>

          {/* Support Link */}
          <p 
            className="cy:m-0 cy:text-gray-600" 
            style={{ fontSize: '14px', fontWeight: 400, lineHeight: '140%' }}
          >
            Still facing issues?{' '}
            <a
              href={supportUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="cy:text-blue-600 cy:underline cy:hover:text-blue-700"
            >
              Contact support
            </a>
          </p>
        </div>
      </Card>
    </div>
  );
};

